var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouajanat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8 17.36C51.18 15.74 48.14 16.05 46.36 14.92C44.45 13.7 43.33 10.79 41.32 10.15C39.22 9.47999 36.81 11.27 34.68 11.22C32.55 11.17 30.06 9.26999 27.99 9.84999C26 10.41 25.01 13.27 23.16 14.4C21.44 15.45 18.38 15 16.83 16.56C15.28 18.11 15.73 21.17 14.67 22.89C13.54 24.75 10.67 25.74 10.12 27.72C9.54 29.79 11.44 32.28 11.49 34.41C11.54 36.54 9.74 38.95 10.41 41.05C11.06 43.06 13.96 44.18 15.18 46.09C16.31 47.86 16 50.9 17.62 52.52",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.24 52.36C18.86 53.98 21.9 53.67 23.68 54.8C25.59 56.02 26.71 58.93 28.72 59.57C30.82 60.24 33.23 58.45 35.36 58.5C37.49 58.55 39.98 60.45 42.05 59.87C44.04 59.31 45.03 56.45 46.88 55.32C48.6 54.27 51.66 54.72 53.21 53.16C54.76 51.61 54.31 48.55 55.37 46.83C56.5 44.97 59.37 43.98 59.92 42C60.5 39.93 58.6 37.44 58.55 35.31C58.5 33.18 60.3 30.77 59.63 28.67C58.98 26.66 56.08 25.54 54.86 23.63C53.73 21.86 54.04 18.82 52.42 17.2",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.18 60.48C-2.35 46.96 -1.63 27.51 12.94 12.94C27.5 -1.63 46.95 -2.35 60.48 11.17",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89 9.42C72.42 22.95 71.7 42.4 57.13 56.97C42.56 71.54 23.11 72.26 9.59 58.73",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.06,
    height: 69.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouajanat);
export default __webpack_public_path__ + "static/media/mouajanat.21388e0d54c0162f8d79db52c6aee5e3.svg";
export { ForwardRef as ReactComponent };